import gql from 'graphql-tag'

export default object => {
	return {
		mutation: gql`
			mutation insert_pdf_templates_one($object: pdf_templates_insert_input!) {
				insert_pdf_templates_one(object: $object) {
					id
				}
			}
		`,
		variables: {
			object: {
				name: object.name,
				organization_id: object.organizationId,
				country: object.country,
				comercial_base: object.comercialBase,
				contract_type: object.contractType,
				comercial_category_id: object.comercialCategoryId,
				template_url: object.templateUrl
			}
		}
	}
}
